export const ColorName = ["primary", "neutral", "danger", "success", "alert", "gradient"];
export const ColorCode = [900, 800, 700, 600, 500, 400, 300, 200, 100, 0];
export const Color = {
    primary: {
        900: "#00527F",
        800: "#006197",
        700: "#006BA6",
        600: "#0077B6",
        500: "#008CBA",
        400: "#00A7DD",
        300: "#75C3F3",
        200: "#8FCFF6",
        100: "#C6E5F7"
    },
    neutral: {
        900: "#383D47",
        800: "#4C515B",
        700: "#585D67",
        600: "#62666E",
        500: "#96999E",
        400: "#ABADB1",
        300: "#D0D0D0",
        200: "#E6E3E3",
        100: "#F5F5F5",
        0: "#FFFFFF"
    },
    danger: {
        800: "#B30D05",
        400: "#EE4137",
        300: "#F1675E",
        100: "#FFBFBD"
    },
    success: {
        800: "#008051",
        500: "#009C63",
        400: "#31AF81",
        300: "#00D185",
        200: "#05FFA4"
    },
    alert: {
        800: "#877503",
        700: "#D1B704",
        600: "#E5CB14",
        500: "#FFD235",
        300: "#FCDD71"
    },
    // Still uses hardcoded primary[600] and primary[900]
    gradient: {
        100: `linear-gradient(-90deg, #0077B6 0%, #00527F 100%)`,
        0: `linear-gradient(-90deg, #FFFFFF 0%, #FFFFFF 100%)`
    }
};
export const ColorSAP = {
    primary: {
        100: "#090A22",
        90: "#181A5B",
        80: "#282A94",
        70: "#3B3FEA",
        60: "#585AE5",
        50: "#7A7CE9",
        40: "#989DEE",
        30: "#BBBDF3",
        20: "#DBDCF8",
        10: "#F0F1FF",
        0: "#FDFDFF"
    },
    secondary: {
        100: "#0D0E04",
        90: "#26250E",
        80: "#3E3C17",
        70: "#585622",
        60: "#73712D",
        50: "#8F8D38",
        40: "#C9C751",
        30: "#EAE63B",
        20: "#F4F29D",
        10: "#FBFAD8",
        0: "#FEFEF6"
    },
    neutral: {
        100: "#000000",
        90: "#2A2E34",
        80: "#383D47",
        70: "#4D515A",
        60: "#595D65",
        50: "#63656E",
        40: "#97999E",
        30: "#ACADB1",
        20: "#D0D0D0",
        15: "#F1F2F1",
        10: "#FBFAFA",
        0: "#FFFFFF"
    },
    danger: {
        100: "#300D0B",
        90: "#4F1612",
        80: "#77211C",
        70: "#9F2B25",
        60: "#C6362E",
        50: "#EE4137",
        40: "#F16158",
        30: "#F4807A",
        20: "#F6A09B",
        10: "#F9C0BC",
        0: "#FAF0E9"
    },
    success: {
        100: "#002A1B",
        90: "#00462C",
        80: "#006943",
        70: "#008B59",
        60: "#00AE6F",
        50: "#00D185",
        40: "#2BD999",
        30: "#55E0AE",
        20: "#80E8C2",
        10: "#AAF0D6",
        0: "#CCF6E7"
    }
};
